import { LoadingBox, Popup } from "component/basic/popup";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Private = () => {
    const navigate = useNavigate();
    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [popupData,setPopupData] =  useState(null);

    useEffect(() => {
        if(localStorage.getItem("token")){
            setLoadingBoxOpen(false);
            navigate(0);
        }else{
            setPopupData({
                addClass:null,
                title:"로그인이 필요한 페이지 입니다.",
                text:null,
                closeType:false,
                closeFunc:(e) => {},
                btnFunc0:(e)=>{
                    navigate(-1)
                },
                btn0:"뒤로가기",
                btn0Type:"subColor",
                btn1:"로그인",
                btn1Type:"",
                btnFunc1:()=>{
                    window.welComeOpen();
                    navigate("/");
                }
            });
            setLoadingBoxOpen(false);
        }
    }, []);

    return (
        <>
            <Popup
                data={popupData}
            />
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Private;